import { splitProps, type Component } from 'solid-js';

function mergeClasses(...classes: (string | undefined)[]): string {
    return classes.filter(Boolean).join(' ');
}

export interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    class?: string;
    [key: string]: any;
}

const Switch: Component<SwitchProps> = (props) => {
    const [local, others] = splitProps(props, ['checked', 'onChange', 'class']);

    const classes = () => mergeClasses('relative h-5 w-9 shrink-0 rounded-full transition-colors', local.checked ? 'bg-foreground' : 'bg-muted', local.class);

    return (
        <button type='button' role='switch' aria-checked={local.checked} onClick={() => local.onChange(!local.checked)} class={classes()} {...others}>
            <span class={`absolute top-0.5 left-0.5 h-4 w-4 rounded-full bg-background transition-transform ${local.checked ? 'translate-x-4' : ''}`} />
        </button>
    );
};

export { Switch };
